import { httpResource } from 'core/resources/httpResource';
import { BaseRestResource } from '@snap-alex/domain-js';
import { transactionResourceUrl } from '../constants';

class TransactionResource extends BaseRestResource {}

export const transactionResource = new TransactionResource(httpResource, transactionResourceUrl);
